import { render, staticRenderFns } from "./ProductUpdateItem.vue?vue&type=template&id=5a820945&"
import script from "./ProductUpdateItem.vue?vue&type=script&lang=js&"
export * from "./ProductUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports